/**
 * Click & Collect Toggle Action
 */

export const runClickCollectToggle = async (data = {}) => {
  try {
    const skus = data.skus || [];
    const mode = data.mode || 'pdp';

    if (!skus.length && mode === 'pdp' && data.variantSku) {
      skus.push(data.variantSku);
    }

    window.dispatchEvent(new CustomEvent('click-collect:open', {
      detail: { mode, skus, ...data },
    }));

    return { success: true, message: 'Click & Collect drawer opened' };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export default runClickCollectToggle;
